import {
  UPDATE_FILTERS,
  TOGGLE_FILTER_MODAL,
  SAVE_FILTER,
  SAVE_FILTER_SUCCESS,
  SAVE_FILTER_FAILURE,
  GET_FILTERS,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_FAILURE,
  TOGGLE_DELETE_FILTER,
  DELETE_FILTER,
  DELETE_FILTER_SUCCESS,
  DELETE_FILTER_FAILURE,
  UPDATE_SELECTED_FILTER,
} from "./constants";

export const updateFilters = (payload) => ({
  type: UPDATE_FILTERS,
  payload,
});

export const toggleFilterModal = (payload) => ({
  type: TOGGLE_FILTER_MODAL,
  payload,
});

export const saveFilter = (payload, onSave) => ({
  type: SAVE_FILTER,
  payload,
  onSave,
});

export const saveFilterSuccess = (payload) => ({
  type: SAVE_FILTER_SUCCESS,
  payload,
});

export const saveFilterFailure = (payload) => ({
  type: SAVE_FILTER_FAILURE,
  payload,
});

export const getFilters = (payload) => ({
  type: GET_FILTERS,
  payload,
});

export const getFiltersSuccess = (payload) => ({
  type: GET_FILTERS_SUCCESS,
  payload,
});

export const getFiltersFailure = (payload) => ({
  type: GET_FILTERS_FAILURE,
  payload,
});

export const toggleDeleteFilter = (payload) => ({
  type: TOGGLE_DELETE_FILTER,
  payload,
});

export const deleteFilter = (payload, onDelete) => ({
  type: DELETE_FILTER,
  payload,
  onDelete,
});

export const deleteFilterSuccess = (payload) => ({
  type: DELETE_FILTER_SUCCESS,
  payload,
});

export const deleteFilterFailure = (payload) => ({
  type: DELETE_FILTER_FAILURE,
  payload,
});

export const updateSelectedFilter = (payload) => ({
  type: UPDATE_SELECTED_FILTER,
  payload,
});
